// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"568":"5dace03c","849":"69245210"}[chunkId] + ".chunk.js";
};